/**
 * Helper unico para Pixel no login app.
 * Sempre passa eventID (4o argumento) para dedupe com CAPI.
 */
export const META_PIXEL_ID = "1939007540126253";

export function trackMetaEvent(eventName, params = {}, eventID) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }

  const options = eventID ? { eventID: String(eventID) } : undefined;
  if (options) {
    window.fbq("track", eventName, params || {}, options);
  } else {
    window.fbq("track", eventName, params || {});
  }
}

export function trackMetaPurchase({ paymentId, value, currency = "BRL" }) {
  const id = String(paymentId || "").trim();
  if (!id) return;

  trackMetaEvent(
    "Purchase",
    {
      content_name: "Assinatura Future Trade",
      content_ids: ["future-trade-annual"],
      content_type: "product",
      value: Number(value) || 0,
      currency,
      num_items: 1,
    },
    `purchase:${id}`
  );
}

/** Advanced Matching apos cadastro/login (PII em claro so no browser da Meta). */
export function applyMetaAdvancedMatching({
  email,
  phone,
  firstName,
  lastName,
  externalId,
} = {}) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }

  const payload = {};
  if (email) payload.em = String(email).trim().toLowerCase();
  if (phone) payload.ph = String(phone).replace(/\D/g, "");
  if (firstName) payload.fn = String(firstName).trim().toLowerCase();
  if (lastName) payload.ln = String(lastName).trim().toLowerCase();
  if (externalId) payload.external_id = String(externalId);

  if (!Object.keys(payload).length) return;
  window.fbq("init", META_PIXEL_ID, payload);
}
